
import { useStore } from "vuex";
import { computed, defineComponent, ref } from "vue";
import InventoryItem from "./InventoryItem.vue";
import GenericButton from "../GenericButton.vue";
import GenericPanel from "../GenericPanel.vue";
import GenericTabs from "../GenericTabs.vue";

export default defineComponent({
  components: {
    InventoryItem,
    GenericButton,
    GenericPanel,
    GenericTabs
},
  name: "LoadMenu",
  setup() {
    const store = useStore();
    const panelState = ref('default')
    const activeSection = ref("HELMETS");
    const toggleActiveSection = (value: string) => {
      activeSection.value = value;
    };
    const selectedTab = ref('HELMETS');
    const handleActiveTab = (tab) => {
      selectedTab.value = tab.name
    }
    const tabs = computed(() => {
      return [
        {
          name: 'HELMETS',
          selected: selectedTab.value === 'HELMETS',
        },
        {
          name: 'ARMORS',
          selected: selectedTab.value === 'ARMORS',
        },
        {
          name: 'WEAPONS',
          title: 'Soon',
          selected: selectedTab.value === 'WEAPONS',
          disabled: true
        },
      ]
    })
    const closePanel = () => {
      store.dispatch('showDefaultCharStats')
    }
    return {
      state: store.state,
      panelState,
      closePanel,
      activeSection,
      toggleActiveSection,
      selectedTab,
      tabs,
      handleActiveTab
    };
  },
});
